// Access token APENAS em memória — o refresh token vive num cookie httpOnly
// que o navegador anexa sozinho em /v1/auth/*. Nenhum token vai mais para o
// localStorage; a sessão é restaurada no boot via POST /auth/refresh
// (TokenApiProvider) enquanto os dados do usuário seguem no storage.
let accessToken: string | null = null

export const setAccessToken = (token: string | null) => {
  accessToken = token
}

export const getAccessToken = (): string | null => accessToken
